import { combineReducers } from "redux";
import reducerUser from "./reducerUser";
import reducerSession from "./reducerSession";
import reducerCache from "./reducerCache";
import reducerPortal from "./reducerPortal";
import reducerIdentity from "./reducerIdentity";
import pkg from "../../package.json";
import { getChainRef, getAppRef } from "../actions/config";

const appReducer = combineReducers({
    session: reducerSession,
    user: reducerUser,
    cache: reducerCache,
    chainRef: getChainRef,
    appRef: getAppRef,
    portal: reducerPortal,
    identity: reducerIdentity,
    storeVersion: () => pkg.storeVersion,
});

const reducer = (state, action) => {
    if (action.type === "clear") {
        state = {
            session: reducerSession(),
            user: reducerUser(),
            cache: reducerCache(),
            identity: reducerIdentity(),
            storeVersion: () => pkg.storeVersion,
        };
    }
    return appReducer(state, action);
};

export default reducer;
